import { useEffect, useState } from "react";
import { AlertTriangle, HardHat, ShieldCheck, Siren, ArrowUpFromLine, Sparkles } from "lucide-react";

const PROMPT = "Two engineers replacing ceiling-mounted air conditioning units in an occupied commercial office.";
const SECTIONS = [
  { icon: AlertTriangle, title: "Hazards identified", tone: "text-[#FFA000]", lines: ["Work at height from podium steps", "Manual handling of AC units (approx. weight [TO BE CONFIRMED])", "Refrigerant handling — F-gas competence required"] },
  { icon: ShieldCheck, title: "Control measures", tone: "text-health", lines: ["Exclusion zone below work area in occupied office", "Two-person lift with mechanical aid", "Electrical isolation & lock-off before removal"] },
  { icon: HardHat, title: "PPE", tone: "text-slate-300", lines: ["Safety footwear, gloves, eye protection", "Hard hat where overhead work exists"] },
  { icon: ArrowUpFromLine, title: "Access arrangements", tone: "text-slate-300", lines: ["Out-of-hours access recommended — confirm with client", "Protect floor finishes and walkways"] },
  { icon: Siren, title: "Emergency procedures", tone: "text-alert", lines: ["Rescue plan for work at height", "Site first aider and nearest A&E [TO BE CONFIRMED]"] },
];

export const HeroDemo = () => {
  const [typed, setTyped] = useState("");
  const [shown, setShown] = useState(0);
  useEffect(() => {
    let i = 0;
    let timer;
    const tick = () => {
      i += 1;
      setTyped(PROMPT.slice(0, i));
      if (i < PROMPT.length) timer = setTimeout(tick, 28);
      else SECTIONS.forEach((_, k) => setTimeout(() => setShown(k + 1), 500 + k * 450));
    };
    timer = setTimeout(tick, 600);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div data-testid="hero-demo" className="relative rounded-3xl border border-white/10 bg-navy-2/80 p-5 shadow-[0_40px_120px_-40px_rgba(0,184,148,0.35)] backdrop-blur-xl">
      <div className="mb-4 flex items-center justify-between">
        <div className="flex gap-1.5"><span className="h-2.5 w-2.5 rounded-full bg-alert/80" /><span className="h-2.5 w-2.5 rounded-full bg-[#FFA000]/80" /><span className="h-2.5 w-2.5 rounded-full bg-health/80" /></div>
        <span className="rounded-full border border-[#FFA000]/40 bg-[#FFA000]/10 px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-widest text-[#FFB733]" data-testid="demo-illustrative-label">Illustrative demo</span>
      </div>
      <div className="rounded-2xl border border-white/10 bg-navy p-4">
        <p className="eyebrow mb-2 flex items-center gap-1.5"><Sparkles className="h-3 w-3" /> Describe the job</p>
        <p className="min-h-[48px] text-sm text-slate-200 caret">{typed}</p>
      </div>
      <div className="mt-4 space-y-2.5">
        {SECTIONS.map((s, i) => (
          <div key={s.title} className={`rounded-xl border border-white/10 bg-white/[0.03] p-3.5 transition-[opacity,transform] duration-500 ${i < shown ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0"}`}>
            <p className={`flex items-center gap-2 text-xs font-semibold ${s.tone}`}><s.icon className="h-3.5 w-3.5" />{s.title}</p>
            <ul className="mt-1.5 space-y-0.5 pl-5 text-xs text-slate-400">{s.lines.map((l) => <li key={l} className="list-disc">{l}</li>)}</ul>
          </div>
        ))}
      </div>
      <div className="mt-4 flex items-center justify-between font-mono text-[10px] uppercase tracking-widest text-slate-500">
        <span>Status: Draft</span><span>Requires competent review</span>
      </div>
    </div>
  );
};
